import { persistReducer, REHYDRATE } from "redux-persist";
import AsyncStorage from '@react-native-community/async-storage';

import MyTheme from "../../Theme/Theme";


// theme is not persisted. But recalculated everytime
const initialState = {isDark: false, lang: 'fr'};


function themeFromKey(isDark) {
  return isDark ? MyTheme.dark : MyTheme.light;
}


function themeReducer(state : any = initialState,action : any){
    let nextState;

    switch (action.type){
        case 'CHANGE_THEME':
            nextState = _changeTheme(state,action);
            return nextState || state;
        case 'CHANGE_LANG':
            nextState = _changeLang(state,action);
            return nextState || state;
        case REHYDRATE:
            return {...state, theme: themeFromKey(state.isDark)}
        default :
            return state;
    }
}

function _changeTheme(state :any,action:any){
    const isDark = action.value;

    return {
        ...state,
        isDark : isDark,
        theme : themeFromKey(isDark)
    }
}

function _changeLang(state :any,action:any){
    const lang=action.value;
    console.log('lang',lang);
    return {
        ...state,
        lang : lang
    }
}


const persistConfig = {
  key: "changeTheme",
  storage : AsyncStorage,
  blacklist: ['theme']
}

export default persistReducer(persistConfig, themeReducer);

